G.WinStarPart = function(x,y,autostart) {

	Phaser.Image.call(this,game,x,y);
	G.changeTexture(this,'starPart');
	this.anchor.setTo(0.5);
	this.visible = false;

	this.scale.setTo(1.5);

	this.grav = G.lnf(0.75);

	if (autostart) {
		this.start();
	}else {
		this.visible = false;
	}

};

G.WinStarPart.prototype = Object.create(Phaser.Image.prototype);

G.WinStarPart.prototype.start = function() {
	this.visible = true;
	this.spdX = G.lnf((Math.random()*25)-12.5) 
	this.spdY = G.lnf((Math.random()*-15)-5);
	this.angle = Math.random()*360;
};

G.WinStarPart.prototype.update = function() {
	
	if (this.visible) {
		this.x += this.spdX;
		this.y += this.spdY;
		this.spdX *= 0.98;
		this.angle += this.spdX;
		this.spdY += this.grav;
		this.alpha -= 0.02;
		if (this.alpha <= 0) {
			this.destroy();
		}
	}


};